const getBase64 = (file) => {
	var files = new Blob([file], { type: 'image/png' });
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
		reader.readAsDataURL(files);
	});
};
export default getBase64;
